/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceFeatureFlagsWithDefaults extends models.FeatureFlagsWithDefaults {
    getFixupPrototypeFunction() { return GovernanceFeatureFlagsWithDefaults.fixupPrototype; }

    static newInstance(model: Partial<GovernanceFeatureFlagsWithDefaults>): GovernanceFeatureFlagsWithDefaults {
        let obj = Object.assign(new GovernanceFeatureFlagsWithDefaults(), model);
        GovernanceFeatureFlagsWithDefaults.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceFeatureFlagsWithDefaults>): GovernanceFeatureFlagsWithDefaults {
        if (!model) return null;
        return GovernanceFeatureFlagsWithDefaults.newInstance(<GovernanceFeatureFlagsWithDefaults> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceFeatureFlagsWithDefaults) {
        if (!obj) return;

        models.GovernanceFeatureFlagsWithDefaults.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceFeatureFlagsWithDefaults): boolean {
        if (models.FeatureFlagsWithDefaults.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceFeatureFlagsWithDefaults.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Flag's default value
     */
    govn_2504_a_test_flag: boolean = false;

}
